import { put } from "redux-saga/effects";
import { GetUserMetadataResponse } from "redmond";
import fetchUserMetadata from "../../../api/v0/user/fetchUserMetadata";
import { actions } from "../actions";

export const staysFilterFtuxLocalStorageKey =
  "stayTypeFilterAwarenessPopperSeen";

export function* fetchHasSeenStaysFilterFtuxSaga(
  _: actions.IFetchHasSeenStaysFilterFtux
) {
  try {
    const isAlreadySeen =
      localStorage.getItem(staysFilterFtuxLocalStorageKey) !== null;

    if (isAlreadySeen) {
      yield put(actions.setHasSeenStaysFilterFtux(true));
      return;
    }
    const res: GetUserMetadataResponse = yield fetchUserMetadata({
      keys: ["hasSeenStayTypeVrFtux"],
    });
    const hasSeenStaysFilterFtuxFromMetadata =
      !!res?.userMetadata?.hasSeenStayTypeVrFtux;

    if (hasSeenStaysFilterFtuxFromMetadata) {
      localStorage.setItem(staysFilterFtuxLocalStorageKey, "true");
    }

    yield put(
      actions.setHasSeenStaysFilterFtux(hasSeenStaysFilterFtuxFromMetadata)
    );
  } catch (e) {
    console.error(e);
  }
}
